import React from 'react'
import Hero from './Hero'
import Experience from './Experience'
import Skills from './Skills'
import Projects from './Projects'
import Contact from './Contact'

const MainPage = () => {
    return (
        <div>
                <Hero />
                <Skills />
                <Experience />
                <Projects />
                <Contact />
        </div>
    )
}

export default MainPage
